'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminController = function () {

  /*@ngInject*/
  function AdminController(User, $http, stats) {
    _classCallCheck(this, AdminController);

    this.menu = [{ title: 'Home', state: 'admin.home' }, { title: 'Applications', state: 'admin.apps' }, { title: 'New', state: 'admin.new' }, { title: 'Report', state: 'admin.report' }, { title: 'Stickers', state: 'admin.stickers' }, { title: 'Users', state: 'admin.users' }, { title: 'Settings', state: 'admin.settings' }];

    this.users = User.query();
    this.stats = stats;
  }

  _createClass(AdminController, [{
    key: 'delete',
    value: function _delete(user) {
      user.$remove();
      this.users.splice(this.users.indexOf(user), 1);
    }
  }]);

  return AdminController;
}();

exports.default = AdminController;


// WEBPACK FOOTER //
// ./client/app/admin/admin.controller.js